import { jsx as _jsx } from "react/jsx-runtime";
import { Container } from "@mui/material";
import { useContainerSettings } from "../../hooks/UseContainerSettings/useContainerSettings";
import { MuiMarkdown_V2 } from "../MuiMarkdown/MuiMarkdown_V2";
import { StyledToolbar } from "../Navigation/StyledToolbar";
export const TopBar = ({ content, topBarBackgroundColor }) => {
    const { containerWidth, isMobile, openedFromMobileApp } = useContainerSettings();
    return (_jsx(StyledToolbar, Object.assign({ backgroundColor: topBarBackgroundColor, className: "topbar-overrides" }, { children: _jsx(Container, Object.assign({ id: "top-bar-container", disableGutters: isMobile || openedFromMobileApp ? true : false, maxWidth: containerWidth, sx: {
                display: "flex",
                px: isMobile ? 1 : 0,
                py: 0.25,
            } }, { children: _jsx(MuiMarkdown_V2, Object.assign({ bgColor: topBarBackgroundColor, isTopBar: true }, { children: content })) })) })));
};
